module.exports = __webpack_public_path__ + "static/media/louise_support.590b2ba3.png";